
        import * as module0 from './controllers/copy_controller.js';import * as module1 from './controllers/sidebar_controller.js';import * as module2 from './controllers/toggle_controller.js'
        const modules = {
            "./controllers/copy_controller.js": module0,
            "./controllers/sidebar_controller.js": module1,
            "./controllers/toggle_controller.js": module2,
        };
        export default modules;
      